module.exports = __webpack_public_path__ + "static/media/unlimitedGamesPlayed_250_500.cda0b385.png";